import { render, staticRenderFns } from "./baomingdian.vue?vue&type=template&id=9b5fd6ee&scoped=true"
import script from "./baomingdian.vue?vue&type=script&lang=js"
export * from "./baomingdian.vue?vue&type=script&lang=js"
import style0 from "./baomingdian.vue?vue&type=style&index=0&id=9b5fd6ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5fd6ee",
  null
  
)

export default component.exports